import * as React from 'react';

const SduiPlaceholderContext = React.createContext(null);

export const WithRenderer = SduiPlaceholderContext.Provider;

export interface SduiPlaceholderProps {
  region: string;
}

export const SduiPlaceholder: React.FC<SduiPlaceholderProps> = ({ region }) => (
  <SduiPlaceholderContext.Consumer>{renderer => renderer(region)}</SduiPlaceholderContext.Consumer>
);
